import React from 'react';
import { Quote } from 'lucide-react';
import { moreTestimonials } from '../data/constants';
export function MoreTestimonials() {
  return <section className="py-16 md:py-24 px-4 max-w-6xl mx-auto" data-id="element-233">
      <div className="text-center mb-10 md:mb-14" data-id="element-234">
        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-235">
          🇦🇷 Historias reales
        </p>
        <h2 className="text-2xl md:text-4xl font-extrabold leading-tight max-w-3xl mx-auto text-slate-900" data-id="element-236">
          Más testimonios <span className="text-primary" data-id="element-237">reales</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-4 md:gap-6" data-id="element-238">
        {moreTestimonials.map((t, i) => <div key={i} className="relative bg-white border border-slate-200 shadow-sm hover:border-primary/40 transition-colors p-6 md:p-7 rounded-2xl flex flex-col" data-id="element-239">
            <Quote className="absolute top-5 right-5 w-7 h-7 text-primary/10" data-id="element-240" />

            <div className="text-yellow-400 text-sm mb-4" data-id="element-241">⭐⭐⭐⭐⭐</div>

            <p className="text-slate-700 italic text-base leading-relaxed mb-5 flex-grow font-medium" data-id="element-242">
              "{t.text}"
            </p>

            <div className="flex items-center gap-3 pt-4 border-t border-slate-100" data-id="element-243">
              <div className="w-12 h-12 rounded-full bg-primary/10 border-2 border-primary/20 flex items-center justify-center font-space-grotesk font-bold text-sm text-primary shrink-0" data-id="element-244">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-245">
                <div className="font-bold text-slate-900 text-sm" data-id="element-246">{t.name}</div>
                <div className="text-xs text-slate-500" data-id="element-247">{t.role}</div>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}